import React from 'react'
import { CobuView, CobuText } from '@cobu/ui'
import Strings from '../constants/Strings'
import CobuLogo from '../assets/icons/CobuLogo'

export function MaintenanceScreen() {
  const strings = Strings.get().maintenanceMode
  return (
    <CobuView
      flex={1}
      jc="center"
      ai="center"
      bg="$background"
      minHeight="100vh"
      padding="$6"
    >
      <CobuView mb="$12">
        <CobuLogo width={140} height={41} fill="#000" />
      </CobuView>
      <CobuText
        variant="heading"
        color="$color"
        ta="center"
        mb="$4"
      >
        {strings.title}
      </CobuText>
      <CobuText
        variant="subheading"
        color="$color"
        ta="center"
        fontWeight="500"
      >
        {strings.subtitle}
      </CobuText>
    </CobuView>
  )
}
